import pmsApi from 'services/api/pms'

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit')

export const fetchPmsSyncStatus = createAsyncThunk(
  'pmsSyncStatus/fetchPmsSyncStatus',
  async () => {
    const res = await pmsApi.syncStatus()
    return res
  }
)

const pmsSyncStatusSlice = createSlice({
  name: 'pmsSyncStatus',
  initialState: { list: [] },
  extraReducers: {
    [fetchPmsSyncStatus.fulfilled]: (state, action) => {
      state.list = action.payload
    }
  }
})

export default pmsSyncStatusSlice
